var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rating"},_vm._l((5),function(n){return _c('div',{key:n,staticClass:"rating__incr",class:{ filled: n <= _vm.normalizeScore }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }